import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LancamentoFinanceiro } from '../../extrato-movimentacoes.component';
import { MovimentacaoService } from '../../../../../shared/services/apis/financas/movimentacao.service';
import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';

export interface ModalAlterarContaResult {
  idContaFinanceira: number;
}

interface ContaOption {
  id: number;
  descricao: string;
}

@Component({
  selector: 'app-modal-alterar-conta',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    SelectPesquisavelComponent,
  ],
  templateUrl: './modal-alterar-conta.component.html',
  styleUrls: ['./modal-alterar-conta.component.css'],
})
export class ModalAlterarContaComponent implements OnInit {
  public isLoading: boolean = false;
  public contaOptions: ContaOption[] = [];
  public contaCtrl = new FormControl<number | null>(null);

  constructor(
    public dialogRef: MatDialogRef<ModalAlterarContaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { lancamentos: LancamentoFinanceiro[] },
    private movimentacaoService: MovimentacaoService
  ) {}

  ngOnInit(): void {
    this.carregarContas();
  }

  private carregarContas(): void {
    this.isLoading = true;
    this.movimentacaoService.getLookup().subscribe({
      next: response => {
        this.isLoading = false;
        if (!response.isError) {
          this.contaOptions = (response.listaContaFinanceira || [])
            .filter(c => c.isAtivo && c.idContaFinanceira)
            .map(c => ({ id: c.idContaFinanceira!, descricao: c.descricao }));
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  public salvar(): void {
    const id = this.contaCtrl.value;
    if (!id) return;
    const result: ModalAlterarContaResult = { idContaFinanceira: id };
    this.dialogRef.close(result);
  }
}
